import React, { Component } from 'react';
import './rules.css';

function Rules() {
    return (
        <div className="First_rulet">
            <div className="Second_rulet">
                <div className="Third_rulet">
                    <div>
                        <p> Впевнений, багато хто грав у цю гру. У неї багато імен і ще більше правил. Ми будемо використовувати наступні: </p>
                        <ol>
                            <li> Мета – скинути швидше всі карти, залишивши супротивника з максимальною кількістю карт; </li>
                            <li> За кожну карту в кінці гри нараховуються бали – 10 за десятку, даму, короля, 15 за туза, 20 за валета (червової, хрестової, і пікової) масті, 40 за валета (бубнової) масті, при закінчені гри валетом з гравця знімаються бали згідно з номіналом валета; </li>
                            <li> Перший, хто перескочив планку 115 балів – програє; </li>
                            <li> Гравець повинен викласти одну або декілька карт одного значення, перша з яких має бути того ж значення або тієї ж масті що була викладена до нього, під час свого ходу, якщо потрібної карти немає він добирає одну карту з колоди, якщо і вона не підходить хід пропускається; </li>
                            <li> Існують виняткові карти після яких виконуються певні дії: </li>
                            <ul>
                                <li> Шестірку – треба обов'язково накрити, беремо карти з колоди, поки не накриємо; </li>
                                <li> Сімка – змушує наступного гравця взяти дві карти за кожну викладену сімку або викласти сімку (чотири сімки це бридж після цього береться вісім карт і підраховуються бали); </li>
                                <li> Вісімка – береться карта і пропустити хід (дві вісімки – дві карти, три – три карти, чотири – чотири карти); </li>
                                <li> Валет – лягає на будь-яку масть і можна замовити будь-яку масть; </li>
                                <li> Туз – наступний гравець пропускає хід; </li>
                            </ul>
                            <li> Гра не завершується шестіркою, семіркою, вісімкою, і тузом; </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Rules;